import { EdiScheduler } from "/react4xp/parts/edi-scheduler/edi-scheduler";

export default (props) => <EdiScheduler {...props} />
